import { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../config/streamFirebaseConfig";
// import * as Sentry from "@sentry/react";

export const useLiveData = () => {
  const [liveChannels, setLiveChannels] = useState([]);
  const [liveStreams, setLiveStreams] = useState({});
  const [endedStreams, setEndedStreams] = useState([]);

  const handleSetLiveStreams = (streams) => {
    const filteredStreams = Object.entries(streams).reduce(
      (filtered, [key, stream]) => {
        if (stream?.videoId && !endedStreams.includes(stream.videoId)) {
          filtered[key] = stream;
        }
        return filtered;
      },
      {}
    );
    setLiveStreams(filteredStreams);
  };

  useEffect(() => {
    try {
      const channelsRef = ref(database, `channels`);
      onValue(
        channelsRef,
        (snapshot) => {
          if (snapshot.exists()) {
            // remove ended streams from live channels
            setLiveChannels(snapshot.val());
          } else {
            setLiveChannels([]);
          }
        },
        (error) => {
          //   Sentry.captureException(error);
        }
      );

      const liveStreamsRef = ref(database, `liveStreams`);
      onValue(
        liveStreamsRef,
        (snapshot) => {
          if (snapshot.exists()) {
            // setLiveStreams(snapshot.val());
            handleSetLiveStreams(snapshot.val());
          } else {
            setLiveStreams([]);
            // Sentry.captureMessage("No data available in Firebase config");
          }
        },
        (error) => {
          //   Sentry.captureException(error);
        }
      );
    } catch (err) {
      console.log(err);
      //   Sentry.captureException(err);
    }
  }, []);

  const addEndedStream = (streamId) => {
    console.log("addEndedStream", streamId);
    const updatedEndedStreams = [...endedStreams, streamId];
    setEndedStreams(updatedEndedStreams);

    // remove ended streams from live streams
    const filteredStreams = Object.entries(liveStreams).reduce(
      (filtered, [key, stream]) => {
        if (stream?.videoId && !updatedEndedStreams.includes(stream.videoId)) {
          filtered[key] = stream;
        }
        return filtered;
      },
      {}
    );
    setLiveStreams(filteredStreams);
  };

  return {
    liveChannels,
    liveStreams,
    addEndedStream,
  };
};
